export enum KycVerificationType {
  Profile,
  Card,
}
